export default __webpack_public_path__ + "static/media/Networking.868c8621.svg";